import WidgetPhone from 'components/Widgets/WidgetPhone';

const PhoneTypeField = ({ selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetPhone
      value={selectItem?.value}
      onChange={(val) =>
        setNewSelectItem({
          value: val ?? ' ',
          setting: {},
        })
      }
      disabled={disabled}
    />
  );
};

export default PhoneTypeField;
